import React from 'react'
import PropTypes from 'prop-types'

// A titled block on the public profile. Lighter than a Card so a full profile
// reads as one page rather than nine boxes. Callers render it only when they
// have content.
const Section = ({ title, aside, children }) => (
  <section className='rounded-xl bg-white p-4 shadow-sm dark:bg-gray-800 sm:p-5'>
    <div className='mb-3 flex items-center justify-between gap-x-3'>
      <h2 className='text-base font-bold text-gray-900 dark:text-white'>{title}</h2>
      { aside }
    </div>
    {children}
  </section>
)

export default Section

Section.propTypes = {
  title: PropTypes.node.isRequired,
  aside: PropTypes.node,
  children: PropTypes.node
}
